





















































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Row, Col, Swipe, SwipeItem, Toast } from "vant";
import "@/common/animate.min.css";
import request from "@/api/index";
import Base from "@/template/public/Base.vue";
import native from "@/common/Native";
import { wxChatShare } from "@/common/wechat";
import nopage from "@/components/404.vue";
import { dateFormat } from "@/common/Utils";
import requestNewchongqing from "@/api/newchongqing";
import VConsole from "vconsole";
import ImageViewComMu from "@/components/imageViewComMu.vue";
import posterV2 from "@/components/posterV2.vue";
import { getData, time } from "@/common/dataCollect";
interface IShareInfo {
  /** 顶图	 */
  shareBg: string;
  /** 分享图标	 */
  shareLogo: string;
  /** 客户端名字	 */
  appName: string;
  /** 客户端下载地址	 */
  downloadUrl: string;
  /** 底图 */
  shareClose: string;
  /** scheme */
  schemeUrl: string;
}
interface IResponse {
  code: number;
  message: string;
  sessionId: string;
  data: IShareInfo;
}

@Component({
  components: {
    "van-row": Row,
    "van-col": Col,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    nopage,
    ImageViewComMu,
    posterV2
  }
})
export default class NewsMultiple extends Base {
  private isShowCover: boolean = false;
  private pictureHeight: string | any = "";

  private imgList: Array<object> = [];
  private imgListV: Array<object> = [];
  private imgInfo: object | any = {};
  private imgMoreList: Array<object | any> = [];
  private isOpenApp: boolean = false;
  private active: number = 0;
  private sli: any | Element;
  private trans: number = 0;
  private transWidth: number = 0;
  private transHeight: number = 0;
  private id: string | any = "";
  private showMore: boolean = true;
  private isScroll: boolean = false;
  private isPlay: boolean = false;
  private isVer: boolean = true;
  private newsId: string = "";
  private appStauts: number = 0;

  private isshowData: boolean = false;
  private changeIndex: number = 0;
  public request = new request();
  private vfrom: string = "";
  private clickIndex: number = 0;
  private requestLoaded: boolean = false;
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  public appId: string = "";
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private isYbp: string = "0";

  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  async mounted(): Promise<void> {
    // let vConsole = new VConsole();
    this.vfrom = this.$route.query.vfrom as string;
    this.appId = (this.$route.query.appId as string) || "";
    this.isYbp = this.$route.query.isYbp as string; // 是否是在阅报屏中打开的 （在阅报屏中打开即是不在端内，但是不能显示app头部提示）
    this.isOpenApp = ZWY_CLOUD.isOpenInApp();
    this.renderResize();
    if (!this.isOpenApp) {
      window.addEventListener("resize", this.renderResize, false);
    }

    setTimeout(() => {
      this.transWidth = document.documentElement.clientWidth;
      this.transHeight = document.documentElement.clientHeight;
      this.active = this.sli.length - 1;
      let box: any = document.getElementsByClassName("box");
      this.id = this.$route.query.id;
      if (this.$route.query.isShow == "1") {
        this.isShowCover = true;
      } else {
        this.isShowCover = false;
      }
      this.getImgList();
      this.getCount();
      let that = this;
      (window as any).appResizeStauts = function appResizeStauts(
        stauts: number
      ) {
        if (stauts == 1 || stauts == 3) {
          that.isShowCover = true;
          that.isOpenApp = true;
        } else {
          that.isShowCover = false;
        }
      };
      this.isOpenApp = ZWY_CLOUD.isOpenInApp();
      if (this.isOpenApp) {
        // get用户信息
        native.getUserInfo().then((response: any) => {
          this.userInfo = response;
          this.getBussinessDetail();
        });
      } else {
        this.getBussinessDetail();
      }
    }, 100);
  }
  //横竖屏监听
  beforeDestroy() {
    // window.removeEventListener("resize", this.renderResize, false);
  }

  renderResize() {
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    if (width > height) {
      //横
      this.isShowCover = true;
      this.sli = document.querySelectorAll(".v-swiper-slide");
      this.isScroll = true;
      this.isVer = false;
    } else {
      //竖
      this.isVer = true;
      this.isShowCover = false;
      this.sli = document.querySelectorAll(".swiper-slide");
    }
  }
  //多图
  getImgList() {
    return this.request
      .getList(this.id)
      .then(res => {
        if (res.code === 0) {
          // console.log(res.data);
          this.imgInfo = res.data;
          if (this.imgInfo.audioUrl) {
            this.isPlay = true;
          } else {
            this.isPlay = false;
          }
          document.title = this.imgInfo.richTitle || this.imgInfo.title;
          this.imgList = this.imgInfo.appResource;
          // this.imgListV = this.imgInfo.appResource;
          this.imgListV = [...this.imgList].reverse();
          // for (let i = this.imgList.length - 1; i >= 0; i--) {
          //   this.imgListV.push(this.imgList[i]);
          // }
          this.infoClassifyId = this.imgInfo.infoClassifyId;
          // this.appId = this.imgInfo.appId;
          // this.$store.commit("SET_STATE", {
          //   appId: this.appId
          // });
          // 分享信息获取
          this.getBaseappInfoConfigList(this.imgInfo.appId);
          this.detailGetAppId = this.imgInfo.appId;
          const el = this.$refs.ImageViewCom as any;
          el.openView(0);

          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.imgInfo);
              this.dataSource = false;
            }
          });
        }
        this.getMoreImgList();
      })
      .finally(() => {
        this.requestLoaded = true;
      });
  }
  //多图推荐
  getMoreImgList() {
    return this.request
      .getImgMore(this.infoClassifyId)
      .then(res => {
        if (res.code === 0) {
          let data = res.data;
          this.imgMoreList = data.dataList;
          if (this.imgMoreList) {
            this.showMore = true;
          } else {
            this.showMore = false;
          }
        } else {
          this.showMore = false;
        }
      })
      .catch(() => {
        this.showMore = false;
      });
  }
  close() {
    this.isOpenApp = true;
  }
  //
  onChange(index: number) {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    let length = this.sli.length;
    // if (this.changeIndex < index) {
    //   this.swipeup(length - index - 1, 1);
    //   // this.swiperleft(length - index - 1, 1);
    // } else {
    //   this.swipedown(this.active - 1, 1);
    //   // this.swiperright(this.active-1, 1);
    // }
    if (this.isOpenApp) {
      //在app里
      if (this.changeIndex < index) {
        this.swipeup(length - index, 0);
      } else {
        this.swipedown(length - this.changeIndex - 1, 0);
      }
    } else {
      // 不在app里
      if (this.changeIndex < index) {
        this.swiperleft(length - index, 0);
      } else {
        this.swiperright(length - this.changeIndex - 1, 0);
      }
    }
    this.changeIndex = index;
    const el = this.$refs.ImageViewCom as any;
    el.openView(index);
  }
  //box
  isDisplay(i: number) {
    let box: any = document.getElementsByClassName("box");
    if (box[i].getAttribute("class") == "box animated fadeIn") {
      box[i].setAttribute("class", "box animated fadeOut");
    } else if (box[i].getAttribute("class") == "box animated") {
      box[i].setAttribute("class", "box animated fadeOut");
    } else {
      box[i].setAttribute("class", "box animated fadeIn");
    }
  }
  //横屏滑动  v-touch
  swipeup(i: number, m: number) {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    let trans = window.screen.availHeight;
    let length = this.sli.length;
    this.active = i;
    if (!this.imgMoreList) {
      if (this.active < 1) {
        return;
      }
    }
    // let trans;
    if (m == 0) {
      // trans = document.documentElement.clientHeight;
    } else {
      let refswipe: any = this.$refs.swiper;
      refswipe.next();
      // trans = document.documentElement.clientHeight;
    }
    this.sli[this.active].style.transform =
      "translate3d(  0 ," + -trans + "px, 0)";
    this.sli[this.active].style.transitionDuration = 1000 + "ms";
    let box: any = document.getElementsByClassName("box");
    box[this.active - 1].setAttribute("class", "box animated fadeIn");
    // if (m != 1) {
    //   let refswipe: any = this.$refs.swiper;
    //   refswipe.swipeTo(length - i - 1);
    // }
  }
  swipedown(i: number, m: number) {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    let width = document.documentElement.clientWidth;
    let length = this.sli.length;
    if (m == 0) {
      //
    } else {
      let refswipe: any = this.$refs.swiper;
      refswipe.prev();
    }
    this.active = i + 1;
    if (this.active >= this.sli.length) {
      return;
    }
    this.sli[this.active].style.transform = "translate3d(" + 0 + "px, 0, 0)";
    this.sli[this.active].style.transitionDuration = 1000 + "ms";
    let box: any = document.getElementsByClassName("box");
    setTimeout(() => {
      box[this.active - 1].setAttribute("class", "box animated fadeIn");
    }, 3000);
  }
  swiperlastdown() {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    this.sli[0].style.transform = "translate3d(" + 0 + "px, 0, 0)";
    // this.sli[0].style.transform = "translate3d( 0," + this.trans + "px, 0)";s
    this.sli[0].style.transitionDuration = 1000 + "ms";
  }
  // app外的自适应横屏
  swiperleft(i: number, m: number) {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    let length = this.sli.length;
    this.active = i;
    if (!this.imgMoreList) {
      if (this.active < 1) {
        return;
      }
    }
    let trans = document.documentElement.clientWidth;
    if (m === 0) {
      // trans = document.documentElement.clientHeight;
    } else {
      // trans = document.documentElement.clientWidth;
      let refswipe: any = this.$refs.swiper;
      refswipe.next();
    }
    this.sli[this.active].style.transform =
      "translate3d(" + -trans + "px, 0, 0)";
    this.sli[this.active].style.transitionDuration = 1000 + "ms";
    let box: any = document.getElementsByClassName("box");
    box[this.active - 1].setAttribute("class", "box animated fadeIn");
  }
  swiperright(i: number, m: number) {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    let width = document.documentElement.clientWidth;
    let length = this.sli.length;
    this.active = i + 1;
    if (this.active >= this.sli.length) {
      return;
    }
    if (m == 0) {
      //
    } else {
      let refswipe: any = this.$refs.swiper;
      refswipe.prev();
    }
    this.sli[this.active].style.transform = "translate3d(" + 0 + "px, 0, 0)";
    this.sli[this.active].style.transitionDuration = 1000 + "ms";
    let box: any = document.getElementsByClassName("box");
    setTimeout(() => {
      box[this.active - 1].setAttribute("class", "box animated fadeIn");
    }, 3000);
  }
  swiperlastright() {
    this.sli = document.querySelectorAll(".v-swiper-slide");
    this.sli[0].style.transform = "translate3d(" + 0 + "px, 0, 0)";
    this.sli[0].style.transitionDuration = 1000 + "ms";
  }
  //唤醒
  openApp() {
    this.newsId = this.infoClassifyId;
    const shareInfo = this.shareInfo as IShareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    let schemeUrl = shareInfo.schemeUrl.split("/");
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.newsId,
        sourceId: this.newsId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${this.newsId}&&&sourceId=${this.newsId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.newsId,
        sourceId: this.newsId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      // alert(JSON.stringify(Params));
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }

  intoNews(i: number) {
    this.id = this.imgMoreList[i].id;
    let isShow;
    if (this.isShowCover) {
      isShow = "1";
    } else {
      isShow = "0";
    }
    this.$router.push({
      path: "/multiple/news-multiple",
      query: {
        id: this.imgMoreList[i].id,
        isShow: isShow
      }
    });
    this.$router.go(0);
    this.getImgList();
  }
  next() {
    this.clickIndex++;
    let refswipe: any = this.$refs.swiper;
    refswipe.swipeTo(this.clickIndex);
  }
  prev() {
    let refswipe: any = this.$refs.swiper;
    this.clickIndex--;
    refswipe.swipeTo(this.clickIndex);
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.id,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.id);
    }
  }
}
